// extracted by mini-css-extract-plugin
export default {"button-wrapper":"_Yl-C","buttonWrapper":"_Yl-C","dot":"_3H-dF"};